import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty } from 'lodash';

import MultiselectItem from './MultiselectItem';
import withTranslations from '../../utils/Translations/withTranslations';
import translatePropTypes from '../../../translatePropTypes';
import styles from './MultiselectGroup.scss';

@withTranslations
export default class MultiselectGroup extends React.PureComponent {
  static propTypes = {
    groupTitleKey: PropTypes.string,
    items: PropTypes.array.isRequired,
    itemId: PropTypes.func.isRequired,
    itemTitle: PropTypes.func.isRequired,
    selectedIds: PropTypes.instanceOf(Set).isRequired,
    onToggle: PropTypes.func.isRequired,
    onToggleGroup: PropTypes.func.isRequired,
    first: PropTypes.bool.isRequired,
    textTransformNone: PropTypes.bool,
    labelDividerNone: PropTypes.bool,
    ...translatePropTypes,
  };

  static defaultProps = {
    groupTitleKey: PropTypes.string,
  };

  handleSelectGroup = () => {
    const { items, itemId, selectedIds, onToggleGroup } = this.props;

    const allSelected = items.every(item => selectedIds.has(itemId(item)));

    if (allSelected) {
      onToggleGroup(items, false);
    } else {
      onToggleGroup(items, true);
    }
  };

  render() {
    const {
      groupTitleKey,
      items,
      itemId,
      itemTitle,
      itemStatus,
      selectedIds,
      onToggle,
      first,
      t,
      getHelpNoteTooltipTitle,
      showStatus,
      maxLimitTooltip,
      textTransformNone,
      labelDividerNone,
    } = this.props;

    const fragments = [];

    if (groupTitleKey && !isEmpty(items)) {
      fragments.push(
        <li
          key="groupDividerWithTitle"
          className={classNames(
            'multiselect-item multiselect-group multiselect-group-clickable active',
            {
              [styles.textTransformNone]: textTransformNone,
              [styles.labelDividerNone]: labelDividerNone,
            },
          )}
          onClick={this.handleSelectGroup}
        >
          <label title={getHelpNoteTooltipTitle(t(groupTitleKey))}>
            {t(groupTitleKey)}
          </label>
        </li>,
      );
    } else if (!first && !isEmpty(items)) {
      fragments.push(<li key="groupDivider" className="divider" />);
    }

    for (const item of items) {
      const id = itemId(item);
      fragments.push(
        <MultiselectItem
          key={`item-${id}`}
          id={id}
          maxLimitTooltip={maxLimitTooltip}
          selected={selectedIds.has(id)}
          showStatus={showStatus}
          status={itemStatus(item)}
          title={itemTitle(item)}
          tooltipTitle={getHelpNoteTooltipTitle(itemTitle(item))}
          onToggle={onToggle}
        />,
      );
    }

    return fragments;
  }
}
